import React from 'react'


const Title = ({data}) => {

  return (
    <>
      <h1>{data.page_title}</h1>
    </>
  )
}

export default Title
